// Fireball - Neutral profile ring inside Shopify's account component.
// Shopify exposes no CSS part for the signed-in ring; recheck this selector after component updates.
(() => {
  const ringStyle = new CSSStyleSheet();
  ringStyle.replaceSync(`
    .account-button--shop-customer .account-button__coin-front::after {
      box-shadow: inset 0 0 0 var(--ring-width, 2px) #a1a1aa;
    }
  `);

  const styleAccounts = () => {
    document.querySelectorAll('shopify-account.header__icon').forEach((account) => {
      const root = account.shadowRoot;
      if (root && !root.adoptedStyleSheets.includes(ringStyle)) {
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, ringStyle];
      }
    });
  };

  customElements.whenDefined('shopify-account').then(styleAccounts);
  document.addEventListener('shopify:section:load', styleAccounts);
})();
